module.exports = __webpack_public_path__ + "img/202405_06.04b478b8.jpg";